import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { AppShell } from './components/layout/AppShell';
import { AuthDemoPage } from './routes/AuthDemoPage';
import { ContactDetailPage } from './routes/ContactDetailPage';
import { ContactsPage } from './routes/ContactsPage';
import { DashboardPage } from './routes/DashboardPage';
import { HomePage } from './routes/HomePage';
import { LeadsPage } from './routes/LeadsPage';
import { LoginPage } from './routes/LoginPage';
import { ManagerOpportunitiesPage } from './routes/ManagerOpportunitiesPage';
import { MfaSetupPage } from './routes/MfaSetupPage';
import { MfaVerifyPage } from './routes/MfaVerifyPage';
import { OpportunityDetailPage } from './routes/OpportunityDetailPage';
import { PipelinePage } from './routes/PipelinePage';
import { RecoveryCodePage } from './routes/RecoveryCodePage';
import { ResetPasswordPage } from './routes/ResetPasswordPage';
import { ResetPasswordRequestPage } from './routes/ResetPasswordRequestPage';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/mfa-setup" element={<MfaSetupPage />} />
        <Route path="/mfa-verify" element={<MfaVerifyPage />} />
        <Route path="/recovery-code" element={<RecoveryCodePage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/reset-password-request" element={<ResetPasswordRequestPage />} />
        {/* TEMPORARY: shared auth components demo, dev-only.
            AuthDemoPage returns null in production builds so the route
            effectively 404s in prod. Remove this route along with
            AuthDemoPage.tsx once the real auth pages are validated. */}
        {import.meta.env.DEV ? <Route path="/auth-demo" element={<AuthDemoPage />} /> : null}
        <Route element={<AppShell />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/pipeline" element={<PipelinePage />} />
          <Route path="/leads" element={<LeadsPage />} />
          <Route path="/contacts" element={<ContactsPage />} />
          <Route path="/contacts/:id" element={<ContactDetailPage />} />
          <Route path="/opportunities/:id" element={<OpportunityDetailPage />} />
          <Route path="/manager/opportunities" element={<ManagerOpportunitiesPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
